module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Time-schedule-a5f335510ab124c097d949745ea1cbbe.svg";